import { Component, input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  RdsCardModule,
  RdsIconsModule,
  RdsButtonModule,
  RdsLinkModule,
} from '@rds/angular-components';
import { DynamicModule } from 'ng-dynamic-component';
import { SupportChannel } from '../../../enums/support-channel';
import { OfferingSupportChannel } from '../../../models/offering';

@Component({
  selector: 'inexp-offering-support-channels',
  imports: [
    RdsCardModule,
    RdsIconsModule,
    RdsButtonModule,
    DynamicModule,
    RdsLinkModule,
    RouterModule,
  ],
  templateUrl: './offering-support-channels.component.html',
  styleUrl: './offering-support-channels.component.scss',
})
export class OfferingSupportChannelsComponent {
  _uid = input<string>();
  component = input<string>();
  section = input<string>();
  supportChannels = input<any[]>();

  protected readonly SupportChannel = SupportChannel;

  getDestinationHref(supportChannel: OfferingSupportChannel): string {
    switch (supportChannel.channelType) {
      case SupportChannel.EMAIL:
        return `mailto:${supportChannel.destinationValue}`;
      case SupportChannel.PHONE:
        return `tel:${supportChannel.destinationValue}`;
      case SupportChannel.CHAT:
      case SupportChannel.SERVICE_NOW:
      default:
        return supportChannel.destinationValue;
    }
  }
}
